import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

import { Loader } from '@front/squirtle'

const withContainer = Component => props => {
  const isReady = hooks.useFormStatus('isReady')
  const [isManagingRecord] = hooks.useFormState('isManagingRecord')
  const [isReadOnly] = hooks.useFormState('isReadOnly')
  const [, { openDialog }] = hooks.useDialogs()
  const [record_id] = hooks.useFormState('record_id')
  const [disable2fa] = hooks.useModelFunction('user', 'disable2fa')

  const [has_2fa, , { forceRefresh }] = hooks.useModel('user', [record_id], { single: true, populate: ['auth'], mutator: 'auth.has_2fa', listener_id: 'test' })
  const onDisable2fa = useCallback(async () => {
    await disable2fa({ user_id: record_id });
    forceRefresh()
  }, [record_id, forceRefresh])
  const mergedProps = {
    isManagingRecord,
    isReadOnly,
    openDialog,
    has_2fa,
    onDisable2fa
  }

  return (
    <Loader isLoading={!isReady}>
      <Component {...mergedProps} {...props} />
    </Loader>
  )
}

export default withContainer
